import useStoreType from "../../../utils/hooks/useStoreType";
import { StoreBrandingType } from "../../../types/misc";
import SinglePageSkeletonFullLoading from "./SinglePageSkeletonFullLoading";
import StoreLoadingSkeletonFullSite from "./StoreLoadingSkeletonFullSite";
import ConciergeFullScreenLoading from "./ConciergeFullScreenLoading";

const StoreFullScreenLoading = ({
  storeHeader = false,
}: {
  storeHeader?: boolean;
}) => {
  const storeType = useStoreType();
  const isConciergePage = typeof window !== "undefined" && window.location.pathname.startsWith("/concierge");

  if (isConciergePage) {
    return <ConciergeFullScreenLoading />;
  }
  if (!storeType) {
    return null;
  }
  if (storeType === StoreBrandingType.CustomDTCStore) {
    return <SinglePageSkeletonFullLoading includeHeader={storeHeader} />;
  }
  return <StoreLoadingSkeletonFullSite header={storeHeader} />;
};

export default StoreFullScreenLoading;
